import { Navigate, Route, Routes } from 'react-router-dom';
import ClientLayout from '../components/ClientLayout.jsx';
import ClientHomePage from '../components/client/ClientHomePage.jsx';
import { DemandsArchivedPage, DemandsKanbanPage, DemandsListPage } from '../components/client/DemandsPages.jsx';
import IntakePage from '../components/client/IntakePage.jsx';
import MatterDetailPage from '../components/client/MatterDetailPage.jsx';
import DebtorsPage, { DebtorsArchivedPage } from '../components/client/DebtorsPage.jsx';
import DebtorCreatePage from '../components/client/DebtorCreatePage.jsx';
import DebtorDetailPage from '../components/client/DebtorDetailPage.jsx';
import MessagesPage from '../components/client/MessagesPage.jsx';
import PaymentsPage from '../components/client/PaymentsPage.jsx';
import EvidenceVaultPage from '../components/client/EvidenceVaultPage.jsx';
import LearnPage from '../components/client/LearnPage.jsx';
import SettingsPage from './SettingsPage.jsx';
import {
  ReportDetailPage,
  ReportEditorPage,
  ReportsCollectionsPage,
  ReportsOverviewPage,
  ReportsPipelinePage,
} from '../components/client/ReportsPages.jsx';

export default function ClientPortal() {
  return (
    <Routes>
      <Route element={<ClientLayout />}>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<ClientHomePage />} />
        <Route path="demands" element={<DemandsListPage />} />
        <Route path="demands/list" element={<Navigate to="/client/demands" replace />} />
        <Route path="demands/kanban" element={<DemandsKanbanPage />} />
        <Route path="demands/archived" element={<DemandsArchivedPage />} />
        <Route path="demands/new" element={<IntakePage />} />
        <Route path="demands/:matterId" element={<MatterDetailPage />} />
        <Route path="debtors" element={<DebtorsPage />} />
        <Route path="debtors/archived" element={<DebtorsArchivedPage />} />
        <Route path="debtors/new" element={<DebtorCreatePage />} />
        <Route path="debtors/:debtorId" element={<DebtorDetailPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="evidence-locker" element={<EvidenceVaultPage />} />
        <Route
          path="evidence-vault"
          element={<Navigate to="/client/evidence-locker" replace />}
        />
        <Route path="guides" element={<LearnPage />} />
        <Route path="learn" element={<Navigate to="/client/guides" replace />} />
        <Route path="settings" element={<SettingsPage embedded />} />
        <Route path="banking" element={<Navigate to="/client/payments" replace />} />
        <Route path="reports" element={<ReportsOverviewPage />} />
        <Route path="reports/new" element={<ReportEditorPage />} />
        <Route path="reports/pipeline" element={<ReportsPipelinePage />} />
        <Route path="reports/collections" element={<ReportsCollectionsPage />} />
        <Route path="reports/:reportId/edit" element={<ReportEditorPage />} />
        <Route path="reports/:reportId" element={<ReportDetailPage />} />
        <Route path="*" element={<Navigate to="home" replace />} />
      </Route>
    </Routes>
  );
}
